<template>
  <div class="min-h-240 p-24 bg-bg-subtle border border-dashed border-border-base flex flex-col justify-center items-center gap-2 text-center">
    <img
      alt=""
      :src="icon"
      class="h-48 w-48 mb-12 select-none pointer-events-none"
    >
    <div class="type-headline-sm"> {{ headline }} </div>
    <div class="type-sm text-text-subtle"> {{ text }} </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  headline: string,
  text: string,
  icon: string,
}>();
</script>